import { Component, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from './layouts/layout.component';
// Auth
import { AuthGuard } from './core/guards/auth.guard';
import { ViewPageComponent } from './_commonComponents/view-page/view-page.component';
import { ViewCatalogueComponent } from './_commonComponents/view-catalogue/view-catalogue.component';


const routes: Routes = [
  { path: '', component: LayoutComponent, loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule),canActivate: [AuthGuard]},
  { path: 'auth', loadChildren: () => import('./account/account.module').then(m => m.AccountModule)  },
  {path: 'template', loadChildren: () => import('./pages/templateStore/templateStore.module').then(m => m.templateStoreModule),canActivate: [AuthGuard]},
  {
    path: 'view',
    component: ViewPageComponent
  },
  {
    path: 'view-cat',
    component: ViewCatalogueComponent
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
